import { memo, useEffect, useRef } from 'react'
import lottie from 'lottie-web/build/player/lottie_light_canvas'

function LottiePlayer({ animationUrl, className = 'h-44' }) {
  const containerRef = useRef(null)
  const animationRef = useRef(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container || !animationUrl) {
      return undefined
    }

    let cancelled = false

    fetch(animationUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`)
        }
        return response.json()
      })
      .then((data) => {
        if (cancelled || !container.isConnected) {
          return
        }

        try {
          animationRef.current?.destroy()
        } catch (error) {
          if (error?.name !== 'NotFoundError') throw error
        }
        animationRef.current = null

        const animationData = { ...data }
        delete animationData.tgs

        animationRef.current = lottie.loadAnimation({
          container,
          renderer: 'canvas',
          loop: true,
          autoplay: true,
          animationData,
          rendererSettings: { preserveAspectRatio: 'xMidYMid meet' },
        })
        container.__lottie = animationRef.current
      })
      .catch((error) => {
        console.error('[LottiePlayer] animation_url failed to load:', animationUrl, error)
      })

    return () => {
      cancelled = true
      delete container.__lottie
      try {
        animationRef.current?.destroy()
      } catch (error) {
        if (error?.name !== 'NotFoundError') throw error
      }
      animationRef.current = null
    }
  }, [animationUrl])

  if (!animationUrl) {
    return (
      <div
        className={`mx-auto flex items-center justify-center ${className}`}
        aria-hidden="true"
      />
    )
  }

  return (
    <div
      ref={containerRef}
      data-lottie-player=""
      className={`mx-auto ${className}`}
      aria-hidden="true"
    />
  )
}

export default memo(LottiePlayer)
